var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rev-print"},[_vm._t("header"),_vm._t("info")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }